import React from "react";
import {ChevronDownIcon, XMarkIcon} from "@heroicons/react/24/outline";
import {Popover} from "@headlessui/react";
import CheckboxField from "@/forms/_fields_v2/CheckboxField";

export default function MultiSiteFilter({selectedSiteIds, availableSites, toggleSite, clearSites, id = 'site-filter-btn'}) {

  const [disabled, setDisabled] = React.useState(false);

  const handleToggle = (siteId) => {
    if (disabled) return;
    setDisabled(true);
    setTimeout(() => {
      toggleSite(siteId)
      setDisabled(false);
    }, 0)
  }

  const handleClear = (e) => {
    if (disabled) return;
    if (e && e.stopPropagation) e.stopPropagation();
    setDisabled(true);

    setTimeout(() => {
      clearSites();
      setDisabled(false);
    }, 0)
  }

  return (
    <Popover className="relative">
      {({open}) => (
        <>
          <Popover.Button className="dropdown !active:border-0" id={id}>
            <div>Sites:</div>
            {selectedSiteIds.length > 0 &&
              <div className="badge badge-number text-xs justify-between gap-2">{selectedSiteIds.length} selected
                <button className="rounded-full bg-white text-gray-700" onClick={(e) => handleClear(e)}>
                  <XMarkIcon className=" h-4 w-4"/>
                </button>
              </div>
            }
            {selectedSiteIds.length <= 0 && <span className="font-semibold">All sites</span>}
            <ChevronDownIcon className={`h-5 w-5 transition-transform ${open ? 'rotate-180 transform' : ''}`}/>
          </Popover.Button>

          <Popover.Panel className="absolute z-10 bg-gray-100 translate-y-1 rounded-lg w-96 max-h-96 overflow-auto">
            <ul className="flex flex-col p-2 space-y-2">
              <li><CheckboxField label="All sites" checked={selectedSiteIds.length === 0}
                                 onChange={() => handleClear()} disabled={disabled}/></li>
              {availableSites.map(site => (
                <li key={site.id} data-cy="site-cb">
                  <CheckboxField label={site.name} checked={selectedSiteIds.includes(site.id)}
                                 onChange={() => handleToggle(site.id)} disabled={disabled}/>
                </li>
              ))}
            </ul>
          </Popover.Panel>
        </>
      )}
    </Popover>
  );
}
